import { User } from 'database';
import { AvatarProps, cn } from 'ui';
import { UserAvatar } from './UserAvatar';
import { capitalizeFirstLetter } from 'utils';

export type UserIdentity = Pick<
  User,
  'first_name' | 'last_name' | 'profile_photo' | 'email' | 'id' | 'type'
>;

export const UserDisplay = <T extends UserIdentity>({
  user,
  withAvatar = true,
  children,
  withEmail = true,
  emailClassName = '',
  ...props
}: {
  user: T;
  withAvatar?: boolean;
  children?: React.ReactNode;
  withEmail?: boolean;
  // Forwarded to <UserAvatar> (sizes/styles the avatar, not the root), e.g. `h-4 w-4`.
  className?: string;
  emailClassName?: string;
} & AvatarProps) => {
  return (
    <div className='flex flex-row items-center'>
      {withAvatar && <UserAvatar data={user} {...props} />}

      <div
        className={cn({
          'ml-2': withAvatar,
        })}
      >
        <p className='text-[13px] font-medium leading-none text-foreground-secondary text-nowrap'>
          {capitalizeFirstLetter(user.first_name?.toLowerCase() ?? '')}{' '}
          {capitalizeFirstLetter(user.last_name?.toLowerCase() ?? '')}
        </p>
        {withEmail && (
          <p className={cn('text-xs text-muted-foreground', emailClassName)}>
            {user.email}
          </p>
        )}
        {children}
      </div>
    </div>
  );
};
